<div id="eauth-table">
    <mm-banners *ngIf="showEmailSubmitSuccessNotification" [bannerText]="[confirmationText]" [type]="'confirmation'"></mm-banners>
    <mm-banners *ngIf="showEmailSubmitErrorNotification" [bannerText]="[errorText]" [type]="'error'"></mm-banners>
    <mm-banners *ngIf="(eAuthEmailAddressError$ | async) && !isOptedOut" [bannerText]="['Please enter a valid email address for the selected eAuthorization approver']" [type]="'error'"></mm-banners>
    <mm-banners *ngIf="showWireExtendedProcessDateMesssage" [bannerText]="['Extended same day processing is only available for Electronic Authorization']" [type]="'warning'"></mm-banners>
    <div class="row">
        <div class="column short">
            <span class="column-header">Name</span>
        </div>
        <div class="column long">
            <span class="column-header">Email address</span>
        </div>
        <div class="column short">
            <span class="column-header">eAuthorization setup</span>
        </div>
    </div>
    <sdps-divider variation="primary"></sdps-divider>
    <div *ngFor="let accountHolder of eAuthAccountHolders; let i = index">
        <div id="eauth-table-row" class="row">
            <div id="name-column" class="column short">
                <div class="row">
                    <div>
                        <div class="input-column" data-testid="singleSignerRadioButtons">
                            <input type="radio" [formControl]="accountHolderControl" name="accountHolder"
                                [value]="accountHolder.id" id="{{accountHolder.id}}" 
                                [attr.disabled]="isOptedOut || eAuthClientsResponse.isAccountRestricted || !accountHolder.isEauthEligible || isInitiateAndReleaseFlowFromTable || null"
                                (change)="onAccountHolderSelected()">
                        </div>
                    </div>
                    <div class="label-column">
                        <label for="{{accountHolder.id}}">{{accountHolder.name | name}}</label>
                    </div>
                </div>
            </div>
            <div id="email-column" class="column long">
                <form id="email-form" *ngIf="submitEmailAddressEnabled && !accountHolder.email" [formGroup]="emailForm" (ngSubmit)="onSubmitEmailAddress(accountHolder.id)">
                    <input type="email" id="email-input" name="email" formControlName="emailControl" email="true"
                        (keydown.enter)="onSubmitEmailAddress(accountHolder.id)"
                        [class.error-input]="accountHolder.showSubmitEmailError || ((eAuthEmailAddressError$ | async) && !accountHolder.email && !isOptedOut)">
                    <sdps-button id="email-submit-button" variation="secondary" size="small" type="submit"
                        *ngIf="showSubmitEmailAddressButton">Submit</sdps-button>
                    <div id="email-required-alert" *ngIf="accountHolder.showSubmitEmailError" class="error-text">Valid email address required</div>
                </form>
                <span id="email-address" *ngIf="!submitEmailAddressEnabled || accountHolder.email">{{accountHolder.email}}</span>
            </div>
            <div id="eAuth-setup-column" class="column short">
                <div class="row">
                    <div class="input-column">
                        <div [ngClass]="!displayTooltip(accountHolder) ? 'eauthAuthorized' : 'eauthNotAuthorized'">
                            <div id="eauth-icon">e</div>
                        </div>
                    </div>
                    <div class="label-column">
                        <span *ngIf="!displayTooltip(accountHolder)">{{accountHolder.eligibility}}</span>
                        <span id="eauth-tooltip" *ngIf="displayTooltip(accountHolder)"  [class.error-text]="((eAuthEmailAddressError$ | async) && !accountHolder.email && !isOptedOut)">{{accountHolder.eligibility}}
                            <span id="eauth-tooltip-text" class="no-print">{{accountHolder.eligibilityDetails}}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <sdps-divider *ngIf="i !== eAuthAccountHolders.length - 1" variation="tertiary"></sdps-divider>
    </div>
    <sdps-divider variation="primary"></sdps-divider>
    <div id="opt-out-checkbox" *ngIf="!setupEAuthorizationSelected && !isPalAccount">
        <div class="row">
            <div class="input-column">
                <input type="checkbox" name="optOut" [checked]="isOptedOut" (change)="onOptOutChange()"
                    [attr.disabled]="disableOptOutCheckbox || isInitiateAndReleaseFlowFromTable || null"
                    id="optOutCheckbox" data-testid="optOutCheckbox">
            </div>
            <div class="label-column">
                <label for="optOutCheckbox">Opt out of eAuthorization—we'll generate a prefilled authorization form 
                    to obtain a client signature through Docusign.</label>
            </div>
        </div>
    </div>
    <mm-banners *ngIf="(showMissingEmailMessage$ | async) && isCreateStandingAuth && !setupEAuthorizationSelected && !isOptedOut"
        [bannerText]="[missingEmailMessage]" [type]="'warning'" data-testid="missingEmailMessage"></mm-banners>
    <div *ngIf="eAuthError$ | async" class="eAuth-error">
        <span class="error-text">One client must be selected to continue with this transaction</span>
    </div>
</div>
